import { AdjusterDetail as PcAdjusterDetail } from '@/components/pc/Adjusters';
import { AdjusterDetail as MoAdjusterDetail } from '@/components/mo/Adjusters';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Spin } from 'antd';
import styled from 'styled-components';

const AdjusterDetailPage = () => {
  const isMobile = useIsMobile();

  if (isMobile === null) {
    return (
      <SpinnerWrapper>
        <Spin size="large" />
      </SpinnerWrapper>
    );
  }

  return isMobile ? <MoAdjusterDetail /> : <PcAdjusterDetail />;
};

export default AdjusterDetailPage;

const SpinnerWrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
